import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { ep } from '../api/endpoints';

// マスターデータの型定義
interface MasterDataContextProps {
  staffList: any[];
  branchList: any[];
  departmentList: any[];
  loading: boolean;
}

// コンテキストの初期値
const MasterDataContext = createContext<MasterDataContextProps>({
  staffList: [],
  branchList: [],
  departmentList: [],
  loading: true,
});

// Cloud Functions の URL
const STAFF_LIST_URL = ep('get_staff_list');
const BRANCH_LIST_URL = ep('get_branch_list');
const DEPARTMENT_LIST_URL = ep('get_department_list');

export const MasterDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [staffList, setStaffList] = useState<any[]>([]);
  const [branchList, setBranchList] = useState<any[]>([]);
  const [departmentList, setDepartmentList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  // 初回レンダリング時にマスターデータを一括取得
  useEffect(() => {
    const fetchMasterData = async () => {
      try {
        const [staffRes, branchRes, departmentRes] = await Promise.all([
          axios.post(STAFF_LIST_URL),
          axios.post(BRANCH_LIST_URL),
          axios.post(DEPARTMENT_LIST_URL),
        ]);

        if (staffRes.data.status === 'success') {
          setStaffList(staffRes.data.staffList || []);
        }
        if (branchRes.data.status === 'success') {
          setBranchList(branchRes.data.branchList || []);
        }
        if (departmentRes.data.status === 'success') {
          setDepartmentList(departmentRes.data.departmentList || []);
        }
      } catch (err) {
        console.error("Error fetching master data in MasterDataProvider:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMasterData();
  }, []);

  return (
    <MasterDataContext.Provider value={{ staffList, branchList, departmentList, loading }}>
      {children}
    </MasterDataContext.Provider>
  );
};

/**
 * 他のコンポーネントからマスターデータを取り出すためのカスタムフック
 * 使用例: const { staffList, branchList, departmentList, loading } = useMasterData();
 */
export const useMasterData = () => useContext(MasterDataContext);
